import { useAppSelector } from "../../../../../../stores/hooks/hooks.ts";
import useEmblaCarousel from "embla-carousel-react";
import { usePrevNextButtons } from "../../../../../../helpers/hooks/usePrevNextButtons.ts";
import { RevAvatar, RevLink } from "@revmatics/catalyst";
import {
  NextButton,
  PrevButton,
} from "../../../../../discoverCommunities/components/traditionalView/components/personaDisclosureFilter/components/carouselArrowsBtn/CarouselArrowsBtn.tsx";

export const PersonaAudience = () => {
  const personas = useAppSelector((state) => state.personas.personas);
  const [emblaRef, emblaApi] = useEmblaCarousel({});
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  if (personas && personas.length > 0) {
    return (
      <div className="rounded-lg bg-primary-25 border border-primary-600/14 overflow-hidden">
        <div className="pt-2 px-4 flex items-center gap-2">
          <p className="typography-body-sm text-monochrome-900">Persona(s)</p>
          <p className="typography-body-xs text-monochrome-500">
            {personas.length} total
          </p>
        </div>
        <div className="px-6">
          <div className="embla relative" ref={emblaRef}>
            <div className="embla__container flex gap-3 py-2">
              {personas.map((persona) => (
                <div
                  className="embla__slide min-w-[210px] max-w-[210px]"
                  key={`persona-media-plan-${persona.id}-${persona.name}`}
                >
                  <div className="p-2 h-full bg-white border border-primary-600/14 rounded-lg grid grid-cols-[40px_1fr] items-start gap-3">
                    <RevAvatar
                      variant="circle"
                      size="medium"
                      theme="light"
                      image={
                        persona.persona_picture ||
                        persona.persona_picture_url ||
                        undefined
                      }
                    />
                    <div className="overflow-hidden">
                      <RevLink
                        pathname=""
                        search={`personaId=${persona.id}`}
                        text={persona.name}
                        underline={false}
                      />
                      <p className="typography-body-xs text-monochrome-500 whitespace-nowrap text-ellipsis overflow-hidden">
                        {persona.interests?.join(", ")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <PrevButton
              onClick={onPrevButtonClick}
              disabled={prevBtnDisabled}
              className="w-6 h-full  group absolute top-0 left-0 overflow-y-hidden -translate-x-full z-10 bg-primary-25"
            />
            <NextButton
              onClick={onNextButtonClick}
              disabled={nextBtnDisabled}
              className="w-6 h-full group absolute top-0 right-0 overflow-y-hidden z-10 translate-x-full bg-primary-25"
            />
          </div>
        </div>
      </div>
    );
  }
  return null;
};
